import React from 'react';
import { Card, FormControl, InputLabel, Select, MenuItem, Button, TextField } from '@mui/material';
import { FilterAltOffOutlined } from '@mui/icons-material';
import { SeverityIcon } from './NotificationsTable';
import { getClearBtn } from './NotifRulesUtils';
import { clear } from 'console';

interface Props {
  filters: { account: string; material: string; type: string; showActive: string };
  setFilters: (_filters: any) => void;
  setSearchText: (_text: string) => void;
  searchText: string;
  notificationTypes: { value: string; label: string }[];
}
export const NotifFiltersBar: React.FC<Props> = ({
  filters,
  setFilters,
  setSearchText,
  searchText,
  notificationTypes = [],
}) => {
  const getHandler = (key: keyof typeof filters) => (e: any) => setFilters({ ...filters, [key]: e.target.value || '' });
  const clearFilters = () => {
    setFilters((prev: any) => ({ ...prev, type: '', showActive: 'all' }));
    setSearchText('');
  };

  return (
    <Card className="flex flex-row gap-4 align-top h-12 m-1 p-2 shadow-custom justify-between">
      <div className="flex gap-3">
        <FormControl>
          <TextField
            type="text"
            label="Search..."
            onChange={({ target }) => setSearchText(target.value)}
            variant="outlined"
            value={searchText}
            size="small"
            InputProps={{ endAdornment: searchText ? getClearBtn(() => setSearchText('')) : null }}
            sx={{ '& .MuiInputBase-root': { height: 32, width: 200 }, '& input': { padding: '6px' } }}
          />
        </FormControl>
        <FormControl>
          <InputLabel shrink>Active rules</InputLabel>
          <Select
            className="w-60 h-8"
            displayEmpty
            value={filters.showActive}
            onChange={getHandler('showActive')}
            label="___________"
          >
            <MenuItem value="all">All rules</MenuItem>
            <MenuItem value="active">Only active</MenuItem>
            <MenuItem value="inactive">Only inactive</MenuItem>
          </Select>
        </FormControl>
        <FormControl>
          <InputLabel shrink>Type</InputLabel>
          <Select className="h-8 w-40" displayEmpty value={filters.type} onChange={getHandler('type')} label="_____">
            <MenuItem value="">
              <em>All types</em>
            </MenuItem>
            {notificationTypes.map((t) => (
              <MenuItem key={t.value} value={t.value}>
                <SeverityIcon severity={t.value} />
                {t.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          onClick={clearFilters}
          variant="outlined"
          disabled={filters.showActive === 'all' && !filters.material && !filters.type && !searchText}
        >
          <FilterAltOffOutlined />
        </Button>
      </div>
    </Card>
  );
};
